import { render, staticRenderFns } from "./oderSumbit.vue?vue&type=template&id=7df84d16&scoped=true&"
import script from "./oderSumbit.vue?vue&type=script&lang=js&"
export * from "./oderSumbit.vue?vue&type=script&lang=js&"
import style0 from "./oderSumbit.vue?vue&type=style&index=0&id=7df84d16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df84d16",
  null
  
)

export default component.exports